import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToFontSize, pxToLineHeight } from '@vfit/shared/themes';

export const Title = styled.div<{ haveBorder?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${({ haveBorder }) => (haveBorder ? '18px 16px 18px 20px' : '16px 0 16px 0')};
  border-radius: 5px;
  cursor: pointer;
  border: ${({ haveBorder }) => (haveBorder ? '1px solid #0d0d0d' : 'none')};
  border-bottom: ${({ haveBorder }) => (haveBorder ? '1px solid #0d0d0d' : '1px solid #F2F2F2')};
`;

export const TitleText = styled.h5<{
  color?: string;
  fontFamily?: string;
  fontSize?: string;
  fontWeight?: number;
  isMenu?: boolean;
  lineHeight?: string;
}>`
  font-family: ${({ fontFamily }) => fontFamily || fonts.regular};
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  font-size: ${({ fontSize }) => fontSize || pxToFontSize(18)};
  margin: 0;
  cursor: pointer;
  color: ${({ color }) => color || colors.$262626};
  line-height: ${({ lineHeight }) => lineHeight || pxToLineHeight(18, 28)};

  @media (min-width: ${breakpoints.desktop}) {
    font-weight: ${({ fontWeight }) => fontWeight || 400};
    font-style: normal;
    font-size: ${({ isMenu, fontSize }) => (isMenu && fontSize ? fontSize : '24px')};
    line-height: ${({ lineHeight, isMenu }) => (isMenu && lineHeight ? lineHeight : '30px')};
  }
`;

export const IconSpan = styled.span<{
  color?: string;
  size?: number;
}>`
  cursor: pointer;
  transform: rotate(0deg);
  transition: transform 0.5s;

  &.showing {
    transition: transform 0.5s;
    transform: rotate(-180deg);
  }

  svg {
    width: ${({ size }) => size || 24}px;
    height: auto;

    path {
      stroke: ${({ color }) => color || '#333'};
    }
  }
`;
